import { Grid, TextField, Typography, ButtonBase, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getCommision } from "../../../../helpers/general.helper";
import "./fareSummary.css";
import { retrieveFromLocalStorage } from "../../../Common/Utils";

export default function FareSummary(props) {
  let CommissionDiscount = props.adminCommission.value;

  const flight = useSelector((state) => state.flight.selectedFlight);
  const passengers = useSelector((state) => state.flight.passengers);
  const selectedCurrency = useSelector((state) => state.flight.currency);
  const vendor = useSelector((state) => state.vendor);
  const admin = useSelector((state) => state.admin);
  const ancillaryServices = useSelector(
    (state) => state.flight.ancillaryServices
  );
  const [promo, setPromo] = useState("");
  const [reload, setReload] = useState(true);

  useEffect(() => {
    setReload(false);
  }, [flight]);

  const getBaggagePrice = () => {
    if (!ancillaryServices?.baggage) return 0;
    let totalBaggagePrice = 0;
    Object.values(ancillaryServices.baggage).forEach((baggage) => {
      if (baggage && baggage.Price) {
        return (totalBaggagePrice += parseInt(baggage.Price));
        // Add commission to baggage price
      }
    });
    return Math.round(totalBaggagePrice);
  };

  const getMealPrice = () => {
    if (!ancillaryServices?.meals) return 0;
    let totalMealPrice = 0;
    Object.values(ancillaryServices.meals).forEach((meal) => {
      if (meal.Price) {
        totalMealPrice += parseInt(meal.Price);
      }
    });
    return totalMealPrice;
  };

  const getCommisionPrice = () => {
    let commissionType = "";
    let commissionValue = 0;
    let vendorCurrency;
    if (vendor && vendor.vendorDetail) {
      commissionType = vendor.vendorDetail.commissionType;
      commissionValue = vendor.vendorDetail.commissionValue;
      vendorCurrency = vendor.vendorDetail.currency;
    }
    let adminCommissionType = "Fixed";
    let adminCommissionValue = 0;
    if (admin && admin.commission && admin.commission.commissionType) {
      adminCommissionType = admin.commission.commissionType;
      adminCommissionValue = admin.commission.commissionValue;
    }
    return {
      commissionType: commissionType,
      commissionValue: commissionValue,
      vendorCurrency,
      adminCommissionType,
      adminCommissionValue,
    };
  };

  const getFareRules = () => {
    if (props.flight && props.flight.fare_rules) {
      return props.flight.fare_rules;
    }
    return null;
  };

  const getTotal = () => {
    let price = 0;
    if (props.price) {
      price = parseInt(props.price);
    } else if (props.flight && props.flight.total_price) {
      price = parseInt(props.flight.total_price);
    } else if (props.flight && props.flight.price) {
      price = parseInt(props.flight.price);
    }
    const {
      commissionType,
      commissionValue,
      adminCommissionType,
      adminCommissionValue,
    } = getCommisionPrice();
    price += getCommision(price, commissionType, commissionValue);
    price += getCommision(price, adminCommissionType, adminCommissionValue);

    // Add baggage price
    price += getBaggagePrice();

    // Add meal price
    price += getMealPrice();

    if (CommissionDiscount) price += CommissionDiscount;

    return Math.round(price);
  };

  return flight ? (
    <Grid xs="12" sm="12" md="3" className="summary-container">
      <Grid
        xs="12"
        sm="12"
        style={{ paddingBottom: "1rem", borderBottom: "1px solid #d9d9d9" }}
      >
        <Typography variant="h6">Fare Summary</Typography>
      </Grid>
      <Grid
        xs="12"
        sm="12"
        style={{ padding: "1rem 0", borderBottom: "1px solid #d9d9d9" }}
      >
        <Box style={{ display: "flex" }} justifyContent="space-between">
          <Typography fontWeight={600}>Base Fare</Typography>
          <Typography>
            {selectedCurrency}{" "}
            {flight?.price_dropdown?.base_price ||
              flight.price ||
              flight.total_price}
          </Typography>
        </Box>
        <Box style={{ display: "flex" }} justifyContent="space-between">
          <Typography fontWeight={600}>Other Services</Typography>
          <Typography>
            {selectedCurrency} {flight?.price_dropdown?.fees || 0}
            {/* {getCommisionPrice()} */}
          </Typography>
        </Box>
        {getBaggagePrice() > 0 && (
          <Box style={{ display: "flex" }} justifyContent="space-between">
            <Typography fontWeight={600}>Extra Baggage</Typography>
            <Typography>
              {selectedCurrency} {getBaggagePrice()}
            </Typography>
          </Box>
        )}
        {getMealPrice() > 0 && (
          <Box style={{ display: "flex" }} justifyContent="space-between">
            <Typography fontWeight={600}>Meal Preferences</Typography>
            <Typography>
              {selectedCurrency} {getMealPrice()}
            </Typography>
          </Box>
        )}
        <Box style={{ display: "flex" }} justifyContent="space-between">
          <Typography fontWeight={600}>Commission</Typography>
          <Typography>
            {selectedCurrency} {CommissionDiscount}
          </Typography>
        </Box>
      </Grid>
      <Grid
        xs="12"
        sm="12"
        style={{
          display: "flex",
          borderBottom: "1px solid #d9d9d9",
          padding: "1rem 0",
          gap: "1rem",
        }}
        justifyContent="space-between"
      >
        <TextField
          placeholder="Gift or discount code"
          sx={{
            "&": {
              border: "1px solid #DADADA",
              borderRadius: "4px",
              padding: "0.5rem",
            },
            "& input": {
              padding: 0,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
              padding: 0,
            },
          }}
          value={promo}
          onChange={(e) => setPromo(e.target.value)}
        />
        <ButtonBase
          disabled={promo.length > 0}
          style={{
            backgroundColor: promo.length > 0 ? "#00846A" : " #bfbfbf",
            borderRadius: "0.25rem",
            padding: "0 1.25rem",
            color: "white",
          }}
        >
          Apply
        </ButtonBase>
      </Grid>
      <Grid
        xs="12"
        sm="12"
        style={{ display: "flex", padding: "1rem 0" }}
        justifyContent="space-between"
      >
        <Typography fontWeight={600}>Total Amount</Typography>
        <Typography fontWeight={600}>
          {selectedCurrency} {getTotal()}
        </Typography>
      </Grid>
    </Grid>
  ) : (
    <></>
  );
}
